// Single source of truth for homepage FAQ content.
// Lives in lib/ (no "use client") so both the FAQ component AND the server
// component page.tsx (FAQPage JSON-LD) can import it. Re-exporting from a
// "use client" module turns the array into a client reference and breaks
// SSR.
//
// IMPORTANT: rendered text on the page MUST equal answer text below —
// Google penalizes FAQPage schema/copy mismatch.

export const FAQ_ITEMS: { question: string; answer: string }[] = [
  {
    question: "What channel will my messages come through?",
    answer:
      "New-review alerts can come through email, the dashboard, or optional mobile alerts. WhatsApp is global; Direct Text is available for US/Canada numbers where SMS has been enabled.",
  },
  {
    question: "What if the AI gets a reply wrong?",
    answer:
      "By default, every reply waits for your approval. Review it from the dashboard, email, or an enabled mobile notification, then approve, edit, or skip before anything posts.",
  },
  {
    question: "How long does setup take?",
    answer:
      "About 90 seconds. Sign in with Google, pick the Business Profile you manage, and you're live. Existing reviews are not counted — only new ones from the moment you connect.",
  },
  {
    question: "What happens if I exceed 100 reviews per month?",
    answer:
      "We'll notify you before you hit the cap. We do not auto-bill overage fees; automated reply posting may pause until the next billing cycle unless we separately arrange a higher-volume plan.",
  },
  {
    question: "Can I cancel anytime?",
    answer:
      "Yes. Cancel from your dashboard with one click. You keep access through the end of the billing period, and we never charge you again.",
  },
];
